import Vue from 'vue'
import * as Sentry from '@sentry/browser'

if (process.env.NODE_ENV !== 'development') {
  Vue.config.productionTip = false

  Sentry.init({
    dsn: process.env.VUE_APP_SENTRY_DSN,
    environment: process.env.VUE_APP_SENTRY_ENV,
    release: process.env.VUE_APP_RELEASE,
    integrations: [new Sentry.Integrations.Vue({ Vue })]
  })
}
